import { createContext, useEffect, useReducer } from "react";

export const AdminAuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {

    case "ADMIN_LOGIN":
      localStorage.setItem("admin", JSON.stringify(action.payload));

      return {
        ...state,
        admin: action.payload,
      };

    case "ADMIN_LOGOUT":
      localStorage.removeItem("admin");

      return {
        ...state,
        admin: null,
      };

    case "AUTH_CHECKED":
      return {
        ...state,
        authChecked: true,
      };

      //combines ADMIN_LOGIN & AUTH_CHECKED to avoid loading issues
      case 'INIT_ADMIN_AUTH':
          return {
              ...state,
              admin: action.payload,
              authChecked: true,
          };
       

    default:
      return state;
  }
};

export const AdminAuthContextProvider = ({ children }) => {

  const [state, dispatch] = useReducer(authReducer, {
    admin: null,
    authChecked: false,
  });

  /* useEffect(() => {

    const admin = JSON.parse(localStorage.getItem("admin"));

    if (admin) {
      dispatch({
        type: "ADMIN_LOGIN",
        payload: admin,
      });
    }

    dispatch({ type: "AUTH_CHECKED" });

  }, []); */

  useEffect(() => {
      try {
          const admin = JSON.parse(localStorage.getItem("admin"));

          dispatch({
              type: "INIT_ADMIN_AUTH",
              payload: admin || null,
          });
      } catch {
          dispatch({
              type: "INIT_ADMIN_AUTH",
              payload: null,
          });
      }
  }, []);


  //("AdminAuthContext State ", state);

  return (
    <AdminAuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AdminAuthContext.Provider>
  );
};